import { Dropdown, DropdownItem, DropdownMenu } from 'semantic-ui-react';

import { Icon, Text } from '@britishcouncil/react-admin';
import { generatePath, useLocation, useNavigate } from 'react-router';
import { ROUTING_PATHS } from 'const';

export type LrwSessionOptionsMenuProps = {
  sessionId: number;
  canEdit: boolean;
  canRemove: boolean;
};

export const LrwSessionOptionsMenu = ({
  sessionId,
  canEdit,
  canRemove,
}: LrwSessionOptionsMenuProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { removeLrwSession, editLrwSession } = ROUTING_PATHS;
  const canDisplayOptions = canEdit || canRemove;

  if (!canDisplayOptions) {
    return null;
  }

  return (
    <Dropdown icon={{ name: 'ellipsis vertical', color: 'blue' }}>
      <DropdownMenu direction="left">
        {canEdit && (
          <DropdownItem
            onClick={() => {
              navigate(generatePath(editLrwSession.absolutePath, { sessionId }), {
                state: location.state,
              });
            }}
          >
            <Icon name="pen square" color="blue" />
            <Text color="blue">Edit</Text>
          </DropdownItem>
        )}
        {canRemove && (
          <DropdownItem
            onClick={() => {
              navigate(generatePath(removeLrwSession.absolutePath, { sessionId }), {
                state: location.state,
              });
            }}
          >
            <Icon name="trash alternate" color="red" />
            <Text color="red">Remove</Text>
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};
